import React, { useEffect } from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import Header from "../components/Header";
import EmergencyBanner from "../components/EmergencyBanner";
import Hero from "../components/Hero";
import Services from "../components/Services";
import WhyUs from "../components/WhyUs";
import SeoContent from "../components/SeoContent";
import Reviews from "../components/Reviews";
import CitiesGrid from "../components/CitiesGrid";
import Faq from "../components/Faq";
import MapEmbed from "../components/MapEmbed";
import Footer from "../components/Footer";
import MobileStickyCTA from "../components/MobileStickyCTA";
import { citiesBySlug } from "../data/cities";

const CityPage = () => {
  const { fullSlug } = useParams();
  const prefix = "debouchagecanalisation-";
  const slug = fullSlug && fullSlug.startsWith(prefix) ? fullSlug.slice(prefix.length) : null;
  const city = slug ? citiesBySlug[slug] : null;

  useEffect(() => {
    if (!city) return;
    document.title = `Debouchage canalisation ${city.name} - Au 01.84.16.20.60`;
    const setMeta = (name, content, attr = "name") => {
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setMeta(
      "description",
      `Débouchage canalisation ${city.name} (${city.cp}) : plombier urgence 24h/24, 7j/7. Dégorgement WC, évacuation, curage haute pression. Devis gratuit au 01.84.16.20.60.`
    );
    setMeta(
      "keywords",
      `Debouchage canalisation ${city.name}, Canalisation bouchée ${city.name}, Debouchage Toilette ${city.name}, entreprise de debouchage canalisation 93, societe Debouchage canalisation ${city.name}, probleme canalisation ${city.name}, wc bouché ${city.name}, curage canalisation ${city.name}`
    );
    setMeta(
      "og:title",
      `Debouchage canalisation ${city.name} - Au 01.84.16.20.60`,
      "property"
    );
    window.scrollTo(0, 0);
  }, [city]);

  if (!city) return <Navigate to="/" replace />;

  return (
    <>
      <EmergencyBanner />
      <Header />
      <main>
        <div className="bg-[#0F172A]">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-6">
            <Link
              to="/"
              data-testid="back-home-link"
              className="inline-flex items-center gap-2 text-white/60 hover:text-[#FF5A1F] text-sm font-bold uppercase tracking-wider"
            >
              <ChevronLeft className="w-4 h-4" /> Retour à l'accueil
            </Link>
          </div>
        </div>
        <Hero city={city.name} />
        <Services />
        <WhyUs />
        <SeoContent city={city.name} />
        <Reviews />
        <CitiesGrid />
        <Faq />
        <MapEmbed />
      </main>
      <Footer />
      <MobileStickyCTA />
    </>
  );
};

export default CityPage;
